import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { Marketday } from './marketday.model';
import { MarketdayPopupService } from './marketday-popup.service';
import { MarketdayService } from './marketday.service';

@Component({
    selector: 'jhi-marketday-delete-dialog',
    templateUrl: './marketday-delete-dialog.component.html'
})
export class MarketdayDeleteDialogComponent {

    marketday: Marketday;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private marketdayService: MarketdayService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['marketday', 'marketOperation', 'weekday']);
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete(id: number) {
        this.marketdayService.delete(id).subscribe((response) => {
            this.eventManager.broadcast({
                name: 'marketdayListModification',
                content: 'Deleted an marketday'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-marketday-delete-popup',
    template: ''
})
export class MarketdayDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private marketdayPopupService: MarketdayPopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            this.modalRef = this.marketdayPopupService
                .open(MarketdayDeleteDialogComponent, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketday/marketday-delete-dialog.component.ts